import BlogRightClassicContainer from "../../../../components/pages/blog/blogDetail/BlogRightClassic";

const BlogRightClassic = () => {
  return <BlogRightClassicContainer />;
};

export default BlogRightClassic;
